import  React, {useState, useEffect, useReducer} from 'react';
import SectionHandler from "./sections/SectionHandler";
import FirstSection from "./sections/FirstSection";
import {ToggleName, defaultReducer, Action, State} from "./State"
import {Fetcher} from "./models/Fetcher";
import SignIn, {SignInFetchers} from "./SignIn";
import Header from "./Header";
import {MDXEditorMethods} from "@mdxeditor/editor";


export type StatePageCreate = State & {
    name: string
    caption: string
    imageUuid: string | null
    imageUrl: string | null
    generatedKey: string | null
    pageCreator: Fetcher
    imagerSample: Fetcher
    imagerCreate: Fetcher
    editorReference: React.RefObject<MDXEditorMethods>
}

export type ActionPageCreate = Action |
    { type: 'set-name', name: string, subdomain: string } |
    { type: 'set-caption', payload: string } |
    { type: 'set-image-url', payload: string } |
    { type: 'set-generated', payload: any } |
    { type: 'image-uploaded', uuid: string, url: string}
    ;

function PageCreate(props: {user: null, name: string | null, subdomain: string | null, caption: string | null,
    image_uuid: string | null, image_url: string | null}) {

    // const [levelCount, setLevelCount] = useState(3);
    // const [baseLevel, setBaseLevel] = useState(0);
    // const [isFriend, setIsFriend] = useState(false);
    // const [becomeFriend, setBecomeFriend] = useState(false);
    // const [name, setName] = useState("");


    const initialState: StatePageCreate = {
        user: props.user,
        name: props.name || '',
        caption: props.caption || '',
        emailVerifying: '',
        codeVerifying: '',
        toggles: new Set<ToggleName>(),
        imageUuid: props.image_uuid,
        imageUrl: props.image_url,
        generatedKey: null,
        pageCreator: new Fetcher("/pages/create.json"),
        imagerSample: new Fetcher("/generateds/sample.json"),
        imagerCreate: new Fetcher("/imager/create.json"),
        signInFetchers: new SignInFetchers(),
        editorReference: React.useRef<MDXEditorMethods>(null)
    };

    const reducer = (state: StatePageCreate, action: ActionPageCreate): StatePageCreate => {
        let defaultResult = defaultReducer(state, action as Action);
        if(defaultResult) {return {...state, ...defaultResult};}
        switch (action.type) {
            case 'set-name': {
                return { ...state, name: (action.name)}; //, subdomain: (action.subdomain)};
            }
            case 'set-caption': {
                return { ...state, caption: (action.payload)};
            }
            case 'set-image-url': {
                return { ...state, imageUrl: (action.payload)};
            }
            case 'set-generated': {
                let generated = action.payload;
                state.editorReference.current?.setMarkdown(generated.fan_markdown);
                return { ...state, imageUrl: (generated.image_url), generatedKey: (generated.key), caption: (generated.fan_markdown)};
            }
            case "image-uploaded": {
                return { ...state, imageUrl: action.url, imageUuid: action.uuid, generatedKey: null};
            }
        }
        return state;
    }

    const [state, dispatch] = useReducer(reducer, initialState);
    const signIn = new SignIn(state, dispatch);

    useEffect(() => {
        state.pageCreator.onChange = () => {  dispatch({type: 'change'}) };
        state.imagerSample.onChange = () => {  dispatch({type: 'change'}) };
        state.imagerCreate.onChange = () => {  dispatch({type: 'change'}) };
    });

    const allHandlers = () => {
        const handlers = [];
        let handler : SectionHandler | null = new FirstSection(state, dispatch);
        while(handler) {
            handlers.push(handler);
            handler = handler.nextHandler();
        }
        return handlers;
    }

    return (
        <>
            <Header signIn={signIn} />
            { allHandlers().map( handler => {
                return <>{handler.handle()}</>
            })}
        </>
    );
}

export default PageCreate;
